import { styled } from '@material-ui/core'
import Link from '@material-ui/core/Link'

export default styled(Link)(() => ({
  '&:hover': {
    textDecoration: 'none'
  }
}))
